import { createStateHook, type HookStateFunction } from 'react-sweet-state';

import { type ChatStorePrivateState } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { chatStore } from './chatStore';

export const useCurrentConversationId: HookStateFunction<string, void> = createStateHook(
	chatStore,
	{
		selector: (state: ChatStorePrivateState) => state.currentConversationId,
	},
);
